import { render } from "./RegisterFormSection.vue?vue&type=template&id=52cbe767&scoped=true"
import script from "./RegisterFormSection.vue?vue&type=script&lang=js"
export * from "./RegisterFormSection.vue?vue&type=script&lang=js"

import "./RegisterFormSection.vue?vue&type=style&index=0&id=52cbe767&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cbe767"]])

export default __exports__